import React from 'react';
import moment from 'moment';
import { useInterval } from 'usehooks-ts';
import { unixDiff } from '../../../helpers/times';

import './style.scss';

export default React.forwardRef(({
    startTime,
    endTime,
    timeSize = 0,
    isVertical = false,
    onUpdate = undefined,
    ...props
}, ref) => {
    const [currentTime, setCurrentTime] = React.useState(moment().unix());
    const [progressOffset, setProgressOffset] = React.useState(0);

    useInterval(() => {
        setCurrentTime(moment().unix());
    }, !endTime || endTime < currentTime  ? null : 1000);

    React.useEffect(() => {
        if (startTime) {
            const diff = unixDiff(startTime, currentTime, 'seconds');
            const offset = (diff / 60) * timeSize;
            const progress = {
                top: isVertical ? offset : -1,
                left: isVertical ? -1 : offset,
            };

            setProgressOffset(progress);
            onUpdate(progress);
        }
    }, [currentTime, timeSize]);

    if (!endTime || startTime > currentTime || endTime <= currentTime) {
        return null;
    }

    return (
        <div
            ref={ref}
            className={`schedule-progress schedule-progress--${!isVertical ? 'horizontal' : 'vertical'} ${props.className || ''}`}
            style={{
                ...props.style,
                ...progressOffset,
            }}
        />
    )
});
